var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgVpMark = function SvgVpMark(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.8523 36L10 12H20.3938L29.0523 26.9969L23.8523 36ZM29.0513 12H32.2943L35.002 16.6892L33.3774 19.5015L29.0513 12ZM36.8614 13.4646L36.0183 12H35.0029L36.3568 14.3446L36.8614 13.4646ZM37.1818 12L37.4464 12.4615L37.2864 12.7323L36.8618 12H37.1818ZM37.625 12.1415L37.545 12H37.4465L37.5758 12.2277L37.625 12.1415ZM37.6552 12L37.6858 12.0429L37.6674 12.0735L37.6245 12H37.6552ZM37.6985 12L37.7041 12.0056L37.7097 12H37.6985ZM37.6919 12L37.698 12.0122V12.0245L37.6858 12H37.6919Z",
    fill: "#1A1A1A"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVpMark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/vp-mark.50887a4e.svg";
export { ForwardRef as ReactComponent };